import React from 'react';
import Marketing from '../images/marketing.svg';
import SubServiceSectionMarketing from '../components/SubServiceSectionMarketing';
import { Link } from 'react-router-dom';


const MarketingServices = () => {
  return (
    <div className = "relative">
      <img
        className="h-auto w-full object-cover"
        src={Marketing}
        alt="Marketing Services"
      />
      {/* <div className="absolute top-48 left-4 p-4 bg-opacity-75 bg-black text-white">
        <h1 className="text-2xl sm:text-4xl font-semibold">Marketing Services</h1>
      </div> */}

      <div>

      <section className='text-left mt-6'>
      <h1 className="text-center my-6 text-2xl font-semibold">Marketing Services</h1>
        {/* <h1 className="text-xl font-semibold m-6 text-[#13689b]">Our Managed IT Services ensure a smooth transition and ongoing optimization with a three-step process:</h1> */}
        <p className="text-md text-black px-12 text-justify">
        WhyMe Solutions offers extensive marketing services designed to make your brand shine in a competitive market. Our data-driven and results-focused approach guarantees that your marketing strategies are both impactful and aligned with your business goals. In today's rapidly evolving business environment, a robust marketing strategy is crucial for achieving visibility, growth, and brand loyalty. At WhyMe Solutions, we offer a full range of marketing services that encompass both modern digital strategies and traditional techniques, ensuring a well-rounded approach to engaging your audience and meeting your business goals.
        </p>
        {/* <div className="border border-1 border-[#13689b] mt-4 mx-4"></div> */}
      </section>

      {/* <WeProvideSection /> */}
     

      <section>
        {/* <h2 className="text-xl font-semibold mb-6">Explore our Managed IT Services</h2>
        <p className="text-md text-gray-700 mb-6 px-12">
        Discover our range of Managed IT Services designed to keep your business running smoothly and efficiently. From immediate technical support to collaborative IT management and proactive network administration, our expert team is here to ensure your technology infrastructure is robust and reliable. Learn more about how our services can help you achieve your business goals.
        </p> */}
        
        <SubServiceSectionMarketing/>
        <div className='mb-6'>
        <h2 className="text-xl font-semibold mb-6 mx-6">Get Started with Expert Marketing Services</h2>
        <p className="text-md text-black mb-6 px-12 text-left">
        Maximize efficiency, enhance security, and drive growth with our tailored Marketing Services. Our certified experts provide 24/7 support, proactive monitoring, and strategic Marketing planning to meet your business needs.
        </p>
        
        <Link to="/contact"
        className="inline-block bg-[#13689b] text-white py-3 px-6 rounded-md text-md font-semibold transition-transform transform hover:scale-105">
      Contact Us
      </Link>
        </div>
      </section>

    </div>

    </div>
  )
}

export default MarketingServices
